import {
    $, addAction, INIT, LAYOUT,
} from '@situation/setdesign.util';

const DEFAULT_TRAVEL_FACTOR = 0.15;

function initParallax() {
    const $images = $('.parallax .content-background-image__img');
    let viewportHeight;
    let ticking = false;
    if (!$images.length) {
        return;
    }

    const updateParallax = () => {
        $images.each((i, el) => {
            const $this = $(el);
            const $parent = $this.parents('.content-background-image');
            const rect = $parent[0].getBoundingClientRect();
            const pos = (rect.top / viewportHeight) * $this.data('distance') * -1;
            $this.css('transform', `translate3d(0, ${pos}px, 0)`);
        });

        ticking = false;
    };

    const requestTick = () => {
        if (!ticking) {
            ticking = true;
            requestAnimationFrame(updateParallax);
        }
    };

    const measureItems = () => {
        viewportHeight = SetDesign.viewport.height();
        $images.each((i, el) => {
            const $this = $(el);
            const $parent = $this.parents('.content-background-image');
            const parentHeight = $parent.outerHeight();
            const travelFactor = Number($this.data('parallax-factor')) || DEFAULT_TRAVEL_FACTOR;
            const travel = Math.round(parentHeight * travelFactor);
            $this.css({ height: parentHeight + 2 * travel, top: `${-travel}px` });
            $this.data('distance', 2 * travel);
        });

        requestTick();
    };

    measureItems();
    addAction(LAYOUT, measureItems);
    $(window).on('scroll', requestTick);
}

addAction(INIT, initParallax, 20);
